export default () => {
  return {
    All: ['All'],
    Purchasing: [ 'ShowTemplate_Despatch', 'ShowTemplate_Invoice', 'ShowTemplate_Return', 'ShowTemplate_DirectRequest', 'ShowTemplate_Order', 'ShowTemplate_TransferRequest', 'ShowTemplate_OrderRequest' ],
    CostControl: [ 'ShowTemplate_Production', 'ShowTemplate_ProductionPlanning' ],
    StockItemTransaction: [ 'ShowTemplate_Transfer', 'ShowTemplate_Waste' ]
  }
}
